import React from 'react';
import IntroSection from '../components/IntroSection';
import Widget from '../components/Widget';
import DashboardGrid from '../components/DashboardGrid';
import DashboardTile from '../components/DashboardTile';
import '../assets/styles/HomePage.css'; // Adjust the path as necessary

const HomePage = () => {
  console.log("HomePage is rendering");
  return (
    <>
      <div>
        <main>
          <div className="content-column">
            <Widget />
            <div className = "hometext">
              <IntroSection />
            </div>
          </div>
          <DashboardGrid />
          <DashboardTile />
        </main>
      </div>
    </>
  );
};

export default HomePage;